<template>
  <el-dialog :title="title" :visible.sync="dialogVisible" width="60%"  append-to-body :close-on-click-modal="false" >
    <div class="view pa24">
      <el-form ref="dynamicValidateForm" :model="ruleForm" label-width="120px" class="demo-dynamic" :rules="rules">
        <el-form-item label="所属父级" :prop="parentId">
          <el-select class="main-select-tree"  clearable @clear="setValueNull"
                     @remove-tag="(data)=>{delTag(data)}"
                     v-model="ruleForm.parentName" style="width: 400px;" name='option 1'>
            <el-option v-for="item in optionData(classList)" :label="item.label" :value="item.id" :key="item.id"
                       style="display: none;" />
            <el-tree class="main-select-el-tree" ref="selectelTree" :data="classList" :props='treeProps'
                     highlight-current @node-click="handleNodeClick" :expand-on-click-node="expandOnClickNode"
                     collapse-tags
                     @check="handleNodeChecked"/>
          </el-select>
        </el-form-item>
        <el-form-item label="文件" >
          <el-upload
              ref="upload"
              class="upload-demo"
              :headers="upParams"
              :data="ruleForm"
              drag
              :action="uploadUrl"
              :on-exceed="handleExceed"
              :on-error="handleError"
              :on-success="handleSuccess"
              :on-progress="handleProgress"
              :on-change="handleChange"
              :limit="1"
              accept=".xls,.xlsx"
              :auto-upload="false">
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
            <div class="el-upload__tip" slot="tip">只能上传xls/xlsx文件</div>
          </el-upload>
        </el-form-item>
      </el-form>
      <div class="subBtn">
        <el-button @click="goBack">取消</el-button>
        <el-button type="primary" @click="confirm" :loading="btnLoading">提交</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import {addStoreCode} from '@/api/storeCode.js'
import {noPage,pageClassList} from '@/api/customPageClass.js'
import {fetchWarehouseTree} from '@/api/storeWarehouse.js'
import {storeTypeList} from '@/utils/constant'
export default {
  name: "addStoreCode",
  components: {},
  props: [],
  data() {
    let token = localStorage.getItem("token")
    return {
      uploadUrl: '/api/storeCode/importClass',
      upParams: {
        token: token
      },
      title: '导入产品类别',
      dialogVisible:false,
      ruleForm: {
        parentId:'',
        classType:'',
        parentName: '',

      },
      rules: {
        parentId: [{
          required: true,
          message: '请选择所属类别',
          trigger: 'change'
        }],
      },
      type: 'add',
      id: '',
      classList: [],
      treeProps: {
        children: 'children',
        label: 'allName'
      },
      expandOnClickNode: false,
      parentId: '',
      classType:'',
      fileList:[],
      btnLoading:false,
    };
  },
  computed: {
    dynamicRules() {
      return (index) => {
        return [{
          required: true,
          message: '这是必填项',
          trigger: 'blur'
        },]
      }
    }
  },
  onShow() {
  },
  created() {

  },
  methods: {
    handleNodeChecked (currObj, isChecked)  {
      const nodeDatas = this.$refs.selectelTree.store.nodesMap;
      for (let key in nodeDatas) {
        nodeDatas[key].expanded = false;
      }
      if (isChecked) {
        this.$refs.selectelTree.setCheckedNodes([currObj]);
      }
    },
    handleChange(file, fileList){
      this.fileList = fileList
    },
    handleProgress(file, fileList){
    },
    handleError(err, file, fileList){
      this.btnLoading = false
      this.$message.error("导入失败")
    },
    handleExceed(files, fileList) {
      this.$message.warning("只能上传1个文件");
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },

    closeDialog(){
      this.$emit('getList')
    },
    openDialog(classType){
      this.ruleForm.parentId = ''
      this.ruleForm.parentName = ''
      this.ruleForm.classType = classType
      this.getAllClass(classType)
      if (classType == 0){
        this.title = '导入产品类别'
      }else if (classType == 1){
        this.title = '导入原材料'
      }
      this.dialogVisible=true
    },
    handleSuccess(response, file, fileList){
      this.btnLoading = false
      if (response.code != 200){
        this.$message.error(response.message)
        this.$refs.upload.clearFiles();
      }else {
        this.$message.success("导入成功")
        this.dialogVisible = false
        this.closeDialog()
      }
    },
    getAllClass(codeType){
      let params={
        pageNum: 1,
        pageSize: 100000,
        type:0,
        classType:codeType
      }
      pageClassList(params).then(res => {
        res.data.list.forEach(item => {
          let namePart = item.name ? `${item.name}` : '';
          let inventCodePart = item.inventCode ? `(${item.inventCode})` : '';
          let specNamePart = item.specName ? `(${item.specName})` : '';
          item.allName = `${namePart}${inventCodePart}${specNamePart}`;
        })
        this.classList = [{id:0,allName:'顶级',children:res.data.list}]
      })
    },
    delTag(item){
      this.parentId = ''
    },
    handleNodeClick(obj,node,item) {
      this.ruleForm.parentId = obj.id
      this.ruleForm.parentName = obj.allName
    },
    setValueNull() {
      this.ruleForm.parentId ='';
      this.ruleForm.parentName ='';
    },
    optionData(array, result = []) {
      array.forEach(item => {
        result.push({
          label: item.specName?item.name+"("+item.specName+")":item.name,
          value: item.id,
          hasChild: item.children && item.children.length !== 0
        })
        if (item.children && item.children.length !== 0) {
          this.optionData(item.children, result)
        }
      })
      return JSON.parse(JSON.stringify(result))
    },
    getClssList() {
      this.getAllClass()
      // noPage({classType: 0}).then(res => {
      //   this.classList = this.classList = [{id:'',name:'顶级',children:res.data}]
      // })
    },
    goBack() {
      this.dialogVisible = false
    },
    confirm() {
      if (!this.ruleForm.parentName){
        this.$message.error("请选择所属类别")
        return
      }
      if (this.fileList.length <= 0){
        this.$message.error("请选择文件")
        return
      }
      this.btnLoading = true
      this.$refs.upload.submit();
    },
  },


};
</script>

<style lang="scss" scoped>
.ml10 {
  margin-left: 10 rpx;
}

.children-item {
  width: 50%;
}
.main-select-tree {

}
.orderTitle {
  font-size: 16px;
  font-family: PingFang-SC-Bold, PingFang-SC;
  font-weight: bold;
  color: #000000;
  line-height: 28px;
  padding: 0px 60px 6px 55px;
}

.subBtn {
  text-align: center;
}

.codeType {

}

.codeWrap {
  margin-top: 20px;
}
</style>
